module.exports = __webpack_public_path__ + "static/media/fouji associates.d84e1ee7.jpeg";